export default {
  wrongAddressFormat: 'Formato de dirección incorrecto',
  disconnectWallet: 'Desconectar aplicación',
  memo: 'Nota',
  stage: 'Etapa',
  tokenomics: 'Resumen de la aplicación',
  tokensPurchased: 'Elementos seleccionados',
  youShouldAgree: 'Debes aceptar los términos y condiciones',
  requiredField: 'Campo obligatorio',
  minValueIs: 'El valor mínimo es',
  maxValueIs: 'El valor máximo es',
  cannotCopyToClipboard: 'No se puede copiar al portapapeles',
  copiedToClipboard: 'Copiado al portapapeles',
  failed: 'Acción fallida',
  success: 'Acción realizada con éxito',
  aboutUs: 'Sobre nosotros',
  bonuses: 'Bonos',
  whitepaper: 'Guía',
  team: 'Equipo',
  community: 'Comunidad',
  checkAddress: 'Verificar dirección',
  theUltimateDollum: 'Aplicación DOLLUM definitiva para acceso seguro',
  unlockTheFuture:
    'Desbloquea el futuro con la aplicación DOLLUM. Segura, rápida y lista para todas tus necesidades digitales.',
  currentPrice: 'PLAN ACTUAL',
  bonusToBase: 'BONO AL PLAN BASE',
  raised: 'recaudado',
  listingPrice: 'PRECIO DE LISTA',
  scrollDownTo: 'Desplázate hacia abajo para saber más',
  keyFeaturesOf: 'Características clave de la aplicación DOLLUM',
  essentialDollumFeatures:
    'Funciones esenciales de la aplicación DOLLUM diseñadas para tu seguridad y comodidad.',
  commissionOptimizer: 'Optimizador de rendimiento',
  reduceTransactionCosts:
    'Reduce los costos de recursos eligiendo automáticamente la opción más eficiente.',
  emergencyStopMode: 'Modo de parada de emergencia',
  instantlyProtectAssets:
    'Protege tu cuenta al instante con una sola acción en emergencias.',
  antiHijackFeature: 'Función anti-secuestro',
  lockYourWallet:
    'Bloquea tu aplicación bajo amenaza activando una señal oculta de emergencia.',
  cryptoInvestmentPortfolio: 'Panel personalizado',
  manageYourCrypto:
    'Administra tu contenido con diseños listos para usar en un clic.',
  backupAddress: 'Dirección de respaldo',
  redirectAssetsTo:
    'Redirige los datos a una dirección de respaldo tras largos períodos de inactividad.',
  bonusStages: 'ETAPAS DE BONIFICACIÓN',
  over320Million:
    'Más de 320 millones de personas usan aplicaciones digitales en todo el mundo, creando una creciente demanda de soluciones seguras.',
  tokenStructure: 'ESTRUCTURA DE LA APLICACIÓN',
  onlyEmtVill: '¡SOLO SE EMITIRÁN 210,000,000 UNIDADES DURANTE LA PREVENTA!',
  remainingTokens: 'Unidades asignadas',
  totalRaised: 'Total asignado',
  other: 'Otro',
  is: 'es',
  connectWallet: 'Conectar aplicación',
  operationInProgress: 'Operación en progreso',
  pleaseWait: 'Por favor espera',
  buying: 'Procesando',
  for: 'por',
  confirmThisTransaction: 'Confirma esta acción en tu aplicación',
  changeMetamaskWallet: 'Cambiar aplicación conectada',
  connectedWith: 'Conectado con',
  copyAddress: 'Copiar dirección',
  viewOnExplorer: 'Ver en el explorador',
  checkAddressText:
    'Puedes ingresar la dirección que usaste para registrarte en nuestra aplicación y ver su estado.',
  frozenFor: 'Congelado por ',
  month: 'mes',
  months: 'meses',
  scheduleOfThe: 'Calendario de desbloqueo',
  back: 'ATRÁS',
  available: 'Disponible',
  buy: 'Seleccionar',
  enterTheWallet: 'Ingresa la dirección donde deseas recibir la activación.',
  addressMustBe:
    'La dirección ingresada debe coincidir con la red correcta. De lo contrario, la solicitud se perderá.',
  youAreAt: 'Estás en el paso',
  of: 'de',
  notUseExchangeWallets:
    'No uses cuentas de intercambio, solo aplicaciones compatibles (ej. Metamask, Trust App, Coinbase App)',
  continue: 'Continuar',
  youAreOnLast: 'Estás en el último paso',
  youMustTransfer: 'Debes enviar datos por un monto de',
  address: 'Dirección',
  thisOperationTakes: 'La operación tarda hasta 3 horas en completarse',
  update: 'Actualizar',
  copyTransactionHash: 'Copiar ID de operación',
  copy: 'Copiar',
  depositTheSpecified: 'Enviar los datos especificados a esta aplicación',
  balance: 'Saldo',
  receive: 'Recibir',
  theOperationSuccessful: 'La operación fue exitosa',
  yourFundsWill: 'Tus datos serán entregados a tu aplicación',
  afterTheCompletion:
    'Tras completar todas las etapas, comenzará el proceso de desbloqueo',
  theAmountOf: 'La cantidad de',
  setOneText1: 'Valor de mercado de aplicaciones de $1.5 mil millones en 2023',
  setOneText2:
    '40% de los ingresos del mercado impulsados por plataformas digitales',
  setOneText3:
    '50% de crecimiento en transferencias digitales en la próxima década',
  setTwoText1: '70% de los usuarios prefieren funciones integradas',
  setTwoText2: '$175 millones de ingresos potenciales por ventas de servicios',
  setTwoText3: '10% del suministro total asignado a iniciativas de crecimiento',
  metric: 'Métrica',
  currentMarketState: 'Estado actual del mercado',
  forecastedGrowth: 'Crecimiento previsto',
  userSegments: 'Segmentos de usuarios',
  opportunitiesForDollum: 'Oportunidades para la aplicación DOLLUM',
  marketValue: 'Valor de mercado',
  retailInvestorsFinancial: 'Usuarios generales, instituciones',
  increasingDemandFor: 'Demanda creciente de aplicaciones seguras',
  numberOfCrypto: 'Número de usuarios digitales',
  expectedToReach: 'Se espera que alcance más de 500 millones en 2030',
  youthEntrepreneursInstitutional:
    'Jóvenes, emprendedores, clientes institucionales',
  attractNewUsers: 'Atraer nuevos usuarios mediante innovación',
  mobileWalletShare: 'Participación de aplicaciones móviles',
  belongsToAndroid: 'El 45% del mercado pertenece a Android',
  mobileSolutionsExpected:
    'Se espera que las soluciones móviles crezcan un 10% anual',
  smartphoneUsers: 'Usuarios de smartphones',
  convenienceAndMobile: 'Comodidad y acceso móvil',
  defiAndStacking: 'Funciones avanzadas',
  integrationWithDefi: 'Integración con protocolos externos',
  exponentialGrowthIn: 'Crecimiento exponencial en la demanda de servicios',
  activeCryptoInvestors: 'Usuarios digitales activos',
  directAccessTo: 'Acceso directo a herramientas avanzadas',
  marketRegions: 'Regiones de mercado',
  marketLeaders: 'Líderes de mercado: Norteamérica, Asia',
  asiaAndLatin: 'Asia y América Latina – las más prometedoras',
  entrepreneursAndLow: 'Emprendedores y usuarios emergentes',
  expansionIntoNew: 'Expansión a nuevos mercados',
  millionCryptoUsers: 'millones de usuarios de la aplicación en todo el mundo',
  allocationOfFunds: 'ASIGNACIÓN DE RECURSOS',
  seedRound: 'Etapas de acceso temprano',
  round: 'ronda',
  Round: 'Ronda',
  tokenPrice: 'Valor por unidad',
  privateRound: 'Fase interna',
  presaleRound: 'Etapa preliminar',
  publicSaleRound: 'Ronda de lanzamiento público',
  marketingCommunityBuilding: 'Marketing, construcción de comunidad, Airdrop',
  teamAndFounders: 'Equipo y Fundadores',
  ecosystemDevelopmentFund: 'Fondo de desarrollo del ecosistema',
  liquidityFund: 'Fondo de recursos',
  stakingRewards: 'Recompensas de participación',
  reserveFund: 'Fondo de reserva',
  usersChooseStaking:
    'El 70% de los usuarios eligen funciones de participación en DOLLUM',
  theMajorityOf:
    'La mayoría de los usuarios de la aplicación DOLLUM participan activamente para obtener beneficios constantes y contribuir al crecimiento del ecosistema, aprovechando el alto rendimiento y la seguridad de la aplicación.',
  preliminaryEstimateBased:
    '**Esta es una estimación preliminar basada en las tendencias actuales del mercado.',
  roadmapText1: 'Aplicación sin custodia',
  roadmapText1Part2: 'Funciones principales',
  roadmapText1Part3: 'Guía',
  roadmapText2: 'Aplicación sin custodia',
  roadmapText2Part2: 'Funciones principales ',
  roadmapText2Part3: 'Guía ',
  roadmapText3: 'Anti-secuestro',
  roadmapText3Part2: 'Lanzamiento de la aplicación ',
  roadmapText3Part3: 'Función de dirección de respaldo',
  roadmapText3Part4: 'Transferencia de emergencia ',
  roadmapText3Part5: 'Gestor de portafolio',
  roadmapText4: 'Resumen y lanzamiento de la aplicación',
  roadmapText4Part2: 'Optimizador de rendimiento',
  roadmapText4Part3: 'Mensajes dentro de la operación',
  roadmapText5: 'NFT dentro de la aplicación',
  roadmapText5Part2: 'Comprar servicios con fiat',
  roadmapText5Part3: 'Interactuar usando la función de acceso directo',
  roadmapText6: 'Beta pública',
  roadmapText6Part2:
    'Alianzas estratégicas con empresas globales para integrar DOL como activo estándar.',
  roadmapText6Part3: 'Tarjetas',
  roadmapText6Part4: 'Disponibilizar la aplicación en plataformas',
  roadmapText6Part5: 'Beta del intercambio Dollum',
  roadmapText7: 'Lanzamiento de la aplicación',
  roadmapText7Part2:
    'Adopción de la aplicación como herramienta digital para diversas iniciativas.',
  roadmapText7Part3: 'Blockchain Dollum',
  roadmapText7Part4: 'Beta del mercado NFT',
  roadmapText8: 'Lanzamiento de plataforma',
  roadmapText8Part2: 'Lanzamiento de la plataforma de elementos digitales',
  roadmapText9: 'La Lanzadera',
  roadmapText9Part2:
    'Comenzar la planificación de la siguiente fase de desarrollo',
  tokenRoadmap: 'Hoja de ruta del producto',
  roadmap: 'Hoja de ruta',
  competitorComparison: 'Comparación de referencia',
  featureAttribute: 'Característica/Atributo',
  typeOfWallet: 'Tipo de aplicación',
  custodialNonCustodial: 'Custodia y Sin custodia',
  nonCustodial: 'Sin custodia',
  cryptocurrenciesSupported: 'Formatos compatibles',
  bitcoinEthereumTron: 'Soporte para múltiples formatos',
  thousandCoins: '1,000+ elementos',
  ethereumTokens: 'Tokens estándar',
  assets130: '130+ activos',
  assets500: '500+ activos',
  supportedPlatforms: 'Plataformas compatibles',
  defiIntegration: 'Integración',
  yes: 'Sí',
  stakingSupport: 'Soporte de participación',
  no: 'No',
  tokenSwapping: 'Intercambio de elementos',
  yesNativeExternal: 'Sí (nativo y externo)',
  securityFeatures: 'Funciones de seguridad',
  biometricPassword: 'Biométrico, Contraseña',
  passwordPrivateKey: 'Contraseña, Clave',
  biometric2Fa: 'Biométrico, 2FA',
  kycCompliance: 'Cumplimiento',
  yesForCustodial: 'Sí (para custodia)',
  backupRecovery: 'Copia de seguridad y recuperación',
  yesSeedPhrases: 'Sí (frases, 2FA)',
  yesSeedPhrase: 'Sí (frase)',
  supportedBlockchains: 'Redes compatibles',
  multiBlockChainCustom: 'Multired (personalizable)',
  multiBlockchain: 'Multired',
  userInterface: 'Interfaz de usuario',
  intuitiveCustomizable: 'Intuitiva, personalizable (tema claro/oscuro)',
  simpleCleanInterface: 'Interfaz simple y limpia',
  simpleDeveloperFocused: 'Simple, enfocada en desarrolladores',
  cleanAndUser: 'Limpia y fácil de usar',
  visualAppealing: 'Atractiva, personalizable',
  cleanSimple: 'Limpia, simple',
  crossChainSwapping: 'Intercambio entre redes',
  fees: 'Tarifas',
  adjustableOptimizedUsing:
    'Ajustables, optimizadas con el Optimizador de Rendimiento',
  adjustable: 'Ajustables',
  fixedForCustodial: 'Fijas para custodia; ajustables para sin custodia',
  backupAddressFeature: 'Función de dirección de respaldo',
  yesNonCustodial: 'Sí (sin custodia)',
  pushNotifications: 'Notificaciones push',
  hardwareWalletSupport: 'Soporte de hardware',
  yesViaTrezor: 'Sí (vía Trezor)',
  yesLedgerTrezor: 'Sí (Ledger/Trezor)',
  yesTrezor: 'Sí (Trezor)',
  yesLedger: 'Sí (Ledger)',
  nftSupport: 'Soporte de elementos digitales',
  feeOptimization: 'Optimización de tarifas',
  yesCommissionOptimizer: 'Sí (Optimizador de Rendimiento)',
  twoFactorAuth: 'Autenticación de dos factores (2FA)',
  fiatConversion: 'Conversión a fiat',
  yesCustodialOnly: 'Sí (solo custodia)',
  mobileSpecificFeatures: 'Funciones específicas móviles',
  storiesEmergencyStop: 'Historias, Parada de emergencia, Anti-secuestro',
  none: 'Ninguna',
  adminPanel: 'Panel de administración',
  yesCustodialService: 'Sí (para servicio de custodia)',
  nativeDexAddress: 'Acceso nativo',
  decentralizedAppBrowser: 'Navegador de aplicaciones descentralizadas',
  biometricLogin: 'Inicio de sesión biométrico',
  reputationSystem: 'Sistema de reputación',
  yesInternalWallet: 'Sí (calificación interna de la aplicación)',
  additionalSecurityTools: 'Herramientas de seguridad adicionales',
  emergencyStopAnti: 'Parada de emergencia, Anti-secuestro',
  languagesSupport: 'Idiomas compatibles',
  multiLanguageSupport: 'Soporte multilingüe',
  english: 'Inglés',
  customerSupport: 'Atención al cliente',
  yesBuildIt: 'Sí (opciones de soporte integradas)',
  yesHelpCenter: 'Sí (centro de ayuda)',
  yes24Support: 'Sí (soporte 24/7)',
  yesInApp: 'Sí (soporte en la aplicación)',
  frequentlyAskedQuestions: 'PREGUNTAS FRECUENTES',
  howFindFrequently:
    'Aquí puedes encontrar todas las preguntas frecuentes sobre nuestro producto',
  faqTitle1: '¿Cómo creo una cuenta en la aplicación DOLLUM?',
  faqTitle2: '¿Qué tarifas cobra la aplicación DOLLUM?',
  faqTitle3: '¿La aplicación admite integraciones?',
  faqTitle4: '¿Cómo uso la función de Parada de emergencia?',
  faqTitle5:
    '¿Puede la aplicación DOLLUM usarse para gestionar elementos digitales?',
  faqTitle6: '¿Cómo puedo recuperar el acceso si pierdo mi dispositivo?',
  faqText1:
    'Para crear una cuenta, simplemente descarga la aplicación, completa el registro, elige el tipo (custodia/sin custodia) y guarda de forma segura tu frase de acceso.',
  faqText2:
    'La aplicación DOLLUM optimiza automáticamente el rendimiento seleccionando las tarifas más bajas disponibles, minimizando los costos de los usuarios durante las operaciones.',
  faqText3:
    'Sí, la aplicación DOLLUM admite completamente integraciones, permitiendo a los usuarios participar en servicios externos mediante módulos integrados.',
  faqText4:
    'La función de Parada de emergencia bloquea instantáneamente la aplicación si la seguridad está en riesgo. Puede activarse desde la configuración.',
  faqText5:
    'Sí, la aplicación DOLLUM admite el almacenamiento, visualización y gestión de elementos digitales, permitiendo organizar colecciones digitales de forma segura dentro de la aplicación.',
  faqText6:
    'Puedes restaurar el acceso usando la frase proporcionada durante la creación de la cuenta. Asegúrate de guardarla en un lugar seguro.',
  footerReservedText:
    'El sitio web es operado por SecureLabs LTd incorporada bajo las leyes de Seychelles. Todos los derechos reservados.',
  termsOfUse: 'Términos de uso',
  privacyPolicy: 'Política de privacidad',
  cookiePreferences: 'Preferencias de cookies',
  agreeToTransaction:
    'Acepto la acción, así como las cláusulas descritas en los ',
  and: 'y',
  termsAndConditions: 'Términos y condiciones',
  alsoYouCan: 'También puedes verificar la confirmación de tu asignación en ',
  usingTheTransaction:
    'usando el ID de operación. Siempre puedes ver el calendario detallado de lanzamiento de tus unidades DOL en este sitio proporcionando la dirección receptora.',
  followUsOn: 'Síguenos en redes sociales',
  lockedFor: 'Bloqueado por',
  selectNetwork: 'Seleccionar red',
  dolTokenWill: 'DOL será lanzado en la red Binance Smart Chain',
  copyTxHash: 'Copiar ID de operación',
  theOperationExpired: 'La operación ha expirado',
  waitingTimeHas: 'El tiempo de espera ha expirado, intenta nuevamente',
  ifTheProblem: 'Si el problema persiste, por favor ',
  sendUsEmail: 'envíanos un correo electrónico',
  contactSupport: 'contactar soporte',
  tryAgain: 'Intentar nuevamente',
  theOperationFailed: 'La operación ha fallado',
  error: 'Error',
  tokenUnlockingSchedule: 'Calendario de lanzamiento:',
  promoCodeUsed: 'El código promocional se ha usado con éxito',
  congratulations: 'Felicidades',
  youCanActivate: 'Puedes activar el código promocional por ',
  activateYourPromocode: 'Activa tu código promocional',
  getting: 'Obteniendo',
  totalRaisedInUsd: 'Total recaudado',
  nextStage: 'Siguiente etapa',
  pay: 'Pagar',
  info: 'Información',
  dollumApp: 'Aplicación Dollum',
  trustApp: 'Aplicación Trust',
  metamask: 'Metamask',
  coinbaseApp: 'Aplicación Coinbase',
  exodusApp: 'Aplicación Exodus',
  cryptoComDefi: 'Crypto.com DeFi',
  bonusRowsState1: '1,5 mil millones en 2023',
  bonusRowsGrowth1: '1,5 mil millones en 2023',
  bonusRowsState2: 'Más de 320 millones de usuarios cripto',
  multiformatSupport: 'Soporte multiformato',
  iosAndroidDesktopLightVersion: 'iOS, Android, Escritorio (Versión ligera)',
  iosAndroid: 'iOS, Android',
  iosAndroidChrome: 'iOS, Android, Chrome',
  iosAndroidBrowser: 'iOS, Android, Navegador',
  iosAndroidDesktop: 'iOS, Android, Escritorio',
  biometricPin2Fa:
    'Biométrico, PIN, 2FA, fijación SSL, cifrado AES-256, `Parada de emergencia`, `Anti-hijack`',
  ethereum: 'Ethereum',

  poweredBy: 'Desarrollado por',
  live: 'Live',

  stageTwoAlmostSold: 'Fase 2 casi agotada — Próximo precio: $0.20',
  buyBeforeThePriceIncreases:
    '¡Compra ahora a $0.15 antes de que suba el precio!',
};
